import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import makeStyles from '@mui/styles/makeStyles';
import { InputBase } from '@mui/material';
import { useMessages } from 'modules/intl';

const useStyles = makeStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'white'
    },
    border: '0px'
  },
  input: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.secondary,
    fontWeight: 600,
    '&:hover': {
      border: theme.spacing(0)
    }
  },
  selected: {},
  menuItem: {
    color: theme.palette.text.secondary,
    fontWeight: 600,
    '&$selected': {
      backgroundColor: `${theme.palette.grey[200]} !important`,
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      }
    },
    '&:hover': {
      backgroundColor: theme.palette.common.white
    }
  }
}));

const options = [
  'insights.timeBreakdownChart.collectors',
  'insights.timeBreakdownChart.categories'
];

type SourceDropDownProps = {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  disabled: boolean;
};

const SourceDropDown: React.FC<SourceDropDownProps> = ({
  value,
  onChange,
  disabled
}: SourceDropDownProps) => {
  const dropDownOption = useMessages(options);

  const classes = useStyles();

  return (
    <Box>
      <Select
        value={value}
        onChange={onChange}
        className={classes.root}
        input={<InputBase className={classes.input} />}
        disabled={disabled}
        data-testid="source-drop-down"
      >
        {options.map((i) => {
          return (
            <MenuItem
              key={dropDownOption[i]}
              value={dropDownOption[i]}
              classes={{ selected: classes.selected, root: classes.menuItem }}
              selected={value === dropDownOption[i] ? true : false}
              autoFocus={value === dropDownOption[i] ? true : false}
              data-testid={`source-drop-down-option-${i}`}
            >
              {dropDownOption[i]}
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
};
export default SourceDropDown;
